"use strict";
/**
 * Material Linking System Types (Phase 8)
 *
 * Enables linking personal materials to public materials for inventory tracking
 * Note: 'Private' materials are personal materials owned by individual users
 */
Object.defineProperty(exports, "__esModule", { value: true });
